module.exports = __webpack_public_path__ + "static/coph-153b898e4e8edc9fe454e1f72dff516e.jpg";